<template>
    <div
        data-testid="step-uploadDocument-mobile"
        class="container upload--mobile"
    >
        <div v-if="isShowWelcomeMessage" class="camera-popup">
            <img src="@/assets/camera-permission.png" alt="" />
            <h3>{{ $t(`${translationKey}.browserAccess`) }}</h3>
            <p>{{ $t(`${translationKey}.allowCamera`) }}</p>
            <div class="row">
                <button
                    v-if="!loading"
                    type="button"
                    class="button"
                    @click="handleInitCamera"
                >
                    {{ $t(`${translationKey}.next`) }}
                </button>
                <div
                    v-else
                    class="client-zone-loader"
                    :class="{ oanda: UtilityHelper.isOandaPath() }"
                />
            </div>
        </div>
        <div v-else-if="!isShowWelcomeMessage && noPermissions">
            <div class="container">
                <h1
                    v-if="!isBadUpload"
                    class="container__standard-header"
                    v-html="$t(`${translationKey}.UploadPhotoIdentityDocument`)"
                />

                <div :class="!isMobile && 'recommended_path_container'">
                    <div v-if="!isMobile" class="recommended_header">
                        <div class="recommended_header_lines">
                            <div class="line" />
                            <div class="recommended_header_center">
                                <img
                                    v-if="!UtilityHelper.isOandaPath()"
                                    src="@/assets/phone_icon.svg"
                                    alt="phone icon"
                                />
                                <img
                                    v-if="UtilityHelper.isOandaPath()"
                                    src="@/assets/phone_icon_oanda.svg"
                                    alt="phone icon"
                                />
                                <span>{{
                                    $t(`${translationKey}.alternatePathLabel`)
                                }}</span>
                            </div>
                            <div class="line" />
                        </div>
                    </div>

                    <p
                        v-if="!isBadUpload"
                        class="container__subheader t-bold t-center"
                    >
                        {{ $t(`${translationKey}.IDisClear`) }}
                    </p>
                    <h1
                        v-if="isBadUpload"
                        class="container__standard-header"
                        v-html="$t(`${translationKey}.uploadAgain`)"
                    />
                    <p
                        v-if="isBadUpload"
                        class="container__subheader t-bold t-center"
                    >
                        {{ $t(`${translationKey}.uploadAgainInstructions`) }}
                    </p>
                    <button
                        type="button"
                        class="photo-examples"
                        @click="handleShowPopup"
                    >
                        <span>?</span>
                        {{ $t(`${translationKey}.GoodAndBadPhotoExamples`) }}
                    </button>
                    <p v-if="isBack" class="front-side-thank-you">
                        {{ $t(`${translationKey}.FrontSideThankYou`) }}
                    </p>
                    <div :class="{ 'manual-upload': isPhotoUpload }">
                        <div
                            class="gbg-camera-container desktop-container"
                            :class="{
                                'show-help': showHelp,
                                'show-camera': isShowCamera,
                            }"
                        >
                            <HowToTakePicture
                                v-if="showPopup"
                                :is-popup="true"
                            />
                            <div
                                id="gbgContainer"
                                ref="gbgContainer"
                                class="gbgContainer"
                                :class="{
                                    'oanda-loader': UtilityHelper.isOandaPath(),
                                    'show-loader': showLoader,
                                    'photo-upload': isPhotoUpload,
                                }"
                            />
                        </div>
                    </div>
                </div>
                <div v-if="!isMobile" class="recommended-path-header">
                    <img
                        v-if="!UtilityHelper.isOandaPath()"
                        src="@/assets/phone_icon.svg"
                        alt="phone icon"
                    />
                    <img
                        v-if="UtilityHelper.isOandaPath()"
                        src="@/assets/phone_icon_oanda.svg"
                        alt="phone icon"
                    />
                    <span>{{
                        $t(`${translationKey}.recommendedMobilePathLabel`)
                    }}</span>
                </div>
                <button
                    v-if="!isMobile"
                    type="button"
                    class="navigation-link up-mobile"
                    @click="handleBackToMobileUpload"
                >
                    {{ $t(`${translationKey}.uploadFromMobileButton`) }} »
                </button>
                <p :class="['t-center', { 'is-mobile': isMobile }]">
                    {{ $t(`${translationKey}.skipStepReminder`) }}
                </p>
                <button
                    type="button"
                    class="navigation-link link up-later"
                    @click="handleUploadLater"
                >
                    {{ $t(`${translationKey}.uploadLaterButton`) }} »
                </button>
            </div>
        </div>
        <div v-else>
            <UploadInstructions v-if="showInstructions" />

            <h1
                v-if="isPhotoUpload && !isBadUpload"
                class="container__standard-header"
                v-html="$t(`${translationKey}.UploadPhotoIdentityDocument`)"
            />
            <p
                v-if="isPhotoUpload && !isBadUpload"
                class="container__subheader t-bold t-center"
            >
                {{ $t(`${translationKey}.IDisClear`) }}
            </p>
            <h1
                v-if="isPhotoUpload && isBadUpload"
                class="container__standard-header"
                v-html="$t(`${translationKey}.uploadAgain`)"
            />
            <p
                v-if="isPhotoUpload && isBadUpload"
                class="container__subheader t-bold t-center"
            >
                {{ $t(`${translationKey}.uploadAgainInstructions`) }}
            </p>

            <button
                v-if="isPhotoUpload"
                type="button"
                class="photo-examples"
                @click="handleShowPopup"
            >
                <span>?</span>
                {{ $t(`${translationKey}.GoodAndBadPhotoExamples`) }}
            </button>

            <div v-if="showHowToTakePicture">
                <HowToTakePicture @child-event="handleHowToTakePicture" />
            </div>

            <div
                v-show="!showHowToTakePicture"
                :class="{ 'manual-upload': isPhotoUpload }"
            >
                <div v-show="isSecuringConnection" class="secure-connection">
                    <h2
                        v-html="
                            $t(
                                `${translationKey}.EstabilishingSecureConnection`
                            )
                        "
                    />
                    <div
                        class="client-zone-loader"
                        :class="{ oanda: UtilityHelper.isOandaPath() }"
                    />
                </div>
                <div
                    v-show="!isSecuringConnection"
                    class="gbg-camera-container"
                    :class="{
                        'show-help': showHelp,
                        'show-camera': isShowCamera,
                        'photo-upload': isPhotoUpload,
                        'is-back': isBack,
                    }"
                >
                    <HowToTakePicture v-if="showPopup" :is-popup="true" />
                    <SecurityPopup v-show="securityPopup" />

                    <div v-if="helpAvailable" class="photo-upload-help">
                        <div class="photo-upload-help__background" />
                        <div class="photo-upload-help__content">
                            <div class="photo-upload-help__header">
                                <h3>
                                    {{
                                        $t(`${translationKey}.HowCanWeHelpYou`)
                                    }}
                                </h3>
                            </div>
                            <ul class="photo-upload-help__list">
                                <li @click="showCameraSelection">
                                    <img
                                        src="@/assets/upload-instructions/camera.svg"
                                        alt=""
                                    />
                                    {{
                                        $t(
                                            `${translationKey}.WrongCameraClickHere`
                                        )
                                    }}
                                </li>
                                <li @click="handleShowPopup">
                                    <img
                                        src="@/assets/upload-instructions/howToTakeGoodPicture.svg"
                                        alt=""
                                    />
                                    {{
                                        $t(
                                            `${translationKey}.HowToTakeGoodPicture`
                                        )
                                    }}
                                </li>
                                <li @click="handleManual">
                                    <img
                                        src="@/assets/upload-instructions/switchToManual.svg"
                                        alt=""
                                    />
                                    {{
                                        $t(
                                            `${translationKey}.TakePictureManually`
                                        )
                                    }}
                                </li>
                                <li @click="handleSecurity">
                                    <img
                                        src="@/assets/upload-instructions/securityOfYourData.svg"
                                        alt=""
                                    />
                                    {{
                                        $t(
                                            `${translationKey}.SecurityOfYourData`
                                        )
                                    }}
                                </li>
                                <li @click="handleUpload">
                                    <img
                                        src="@/assets/upload-instructions/skipUpload.svg"
                                        alt=""
                                    />
                                    {{
                                        $t(
                                            `${translationKey}.SkipToUploadFiles`
                                        )
                                    }}
                                </li>
                            </ul>
                        </div>
                    </div>

                    <p
                        v-if="isPhotoUpload && isBack"
                        class="front-side-thank-you"
                    >
                        {{ $t(`${translationKey}.FrontSideThankYou`) }}
                    </p>

                    <div
                        id="gbgContainer"
                        ref="gbgContainer"
                        class="gbgContainer"
                        :class="{
                            'oanda-loader': UtilityHelper.isOandaPath(),
                            'show-loader': showLoader,
                            'photo-upload': isPhotoUpload,
                            'custom-notification': showCustomNotification,
                        }"
                    />
                </div>
            </div>

            <NavigationButton
                v-if="isPhotoUpload"
                path-name="personalDataConfirm"
                :default-look="false"
                :text="$t(`${translationKey}.skipStep`)"
            />
        </div>
    </div>
</template>

<script lang="ts">
import { defineComponent, PropType } from 'vue';
import UploadInstructions from '@/components/UploadInstructions.vue';
import HowToTakePicture from '@/components/steps/HowToTakePicture.vue';
import NavigationButton from '@/components/basic/buttons/NavigationButton.vue';
import SecurityPopup from '@/components/basic/SecurityPopup.vue';
import { UtilityHelper } from '@/helpers/UtilityHelper';

export default defineComponent({
    name: 'UploadDocumentFrontMobileView',

    components: {
        UploadInstructions,
        HowToTakePicture,
        NavigationButton,
        SecurityPopup,
    },

    props: {
        isShowWelcomeMessage: Boolean,
        noPermissions: Boolean,
        loading: Boolean,
        isBadUpload: Boolean,
        isBack: Boolean,
        isMobile: Boolean,
        isPhotoUpload: Boolean,
        showInstructions: Boolean,
        showPopup: Boolean,
        showHelp: Boolean,
        showHowToTakePicture: Boolean,
        isSecuringConnection: Boolean,
        isShowCamera: Boolean,
        helpAvailable: Boolean,
        showLoader: Boolean,
        securityPopup: Boolean,
        showCustomNotification: Boolean,
        translationKey: {
            type: String,
            required: true,
        },
        handleInitCamera: {
            type: Function as PropType<() => void>,
            default: () => {},
        },
        handleShowPopup: {
            type: Function as PropType<() => void>,
            default: () => {},
        },
        handleManual: {
            type: Function as PropType<() => void>,
            default: () => {},
        },
        handleSecurity: {
            type: Function as PropType<() => void>,
            default: () => {},
        },
        handleUpload: {
            type: Function as PropType<() => void>,
            default: () => {},
        },
        handleBackToMobileUpload: {
            type: Function as PropType<() => void>,
            default: () => {},
        },
        handleUploadLater: {
            type: Function as PropType<() => void>,
            default: () => {},
        },
        handleHowToTakePicture: {
            type: Function as PropType<() => void>,
            default: () => {},
        },
        showCameraSelection: {
            type: Function as PropType<() => void>,
            default: () => {},
        },
    },

    setup(props) {
        return {
            UtilityHelper,
            translationKey: props.translationKey,
        };
    },
});
</script>

<style lang="scss" scoped>
.upload--mobile.container {
    padding: 0;
}

.client-zone-loader {
    mask: radial-gradient(farthest-side, #0000 calc(100% - 3px), #000 0);
    -webkit-mask: radial-gradient(
        farthest-side,
        #0000 calc(100% - 3px),
        #000 0
    );
}

.camera-popup {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: white;
    display: flex;
    align-items: center;
    padding-top: 20px;
    z-index: 10;
    display: flex;
    flex-direction: column;

    img {
        display: block;
        margin-bottom: 24px;
    }

    h3 {
        text-align: center;
        font-size: 24px;
        line-height: 32px;
        max-width: 345px;
    }

    p {
        text-align: center;
        font-size: 14px;
        line-height: 21px;
    }
}

.recommended-path-header {
    display: flex;
    justify-content: center;
    align-items: center;
    margin-top: 20px;

    span {
        font-weight: 700;
        font-size: 18px;
    }
}

.recommended_path_container {
    position: relative;
    border: 1px solid #af1919;
    padding: 20px 30px 30px;
    border-top: none;

    &::before {
        content: '';
        position: absolute;
        width: 15%;
        height: 1px;
        background-color: #af1919;
        top: 0;
        left: 0;
    }

    &::after {
        content: '';
        position: absolute;
        width: 15%;
        height: 1px;
        background-color: #af1919;
        top: 0;
        right: 0;
    }

    .recommended_header {
        position: absolute;
        top: -1rem;
        left: 50%;
        transform: translateX(-50%);
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
        flex-direction: column;
        gap: 0.25rem;

        .recommended_header_lines {
            display: flex;
            width: 100%;
            align-items: center;

            .line {
                flex: 1;
            }

            .recommended_header_center {
                display: flex;
                align-items: center;
                max-width: 75%;
                padding: 0 1rem;
                text-align: center;
                font-weight: 700;
                font-size: 18px;
                white-space: normal;
                word-break: break-word;
            }
        }
    }

    div.body.oanda & {
        border-color: #00d37e;

        &::before,
        &::after {
            background-color: #00d37e;
        }
    }
}

.up-mobile {
    margin-top: 20px;
    margin-bottom: 40px;
}

.navigation-link {
    width: fit-content;
    margin-left: auto;
    margin-right: auto;
}

.is-mobile {
    margin-top: 20px;
}
</style>
